import { GeekItem } from '@/models';
import { Season, GeekProfileGeneralScore, OpportunitiesCount } from '@/models/geek-profile';
import { Actions, typedStore } from '@/store';
import Vue from 'vue';

export const geekProfileMixin = Vue.extend({
  data() {
    return {
      loader: {
        isProfilePending: false,
      },
      isNicknameEdited: false,
      activeSeason: {
        start: '',
        end: '',
        id: '',
        isOngoing: false,
        isGlobal: false,
        name: '',
      } as Season,
    };
  },
  created() {
    this.resetStoredGeekProfile();
  },
  computed: {
    currentSeason(): Season {
      return typedStore(this).state.seasons.currentSeason;
    },
    seasons(): Season[] {
      return typedStore(this).state.seasons.seasons;
    },
    geekBasicInfo(): GeekItem {
      return typedStore(this).state.geek.geek;
    },
    geekGeneralScore(): GeekProfileGeneralScore {
      return typedStore(this).state.scores.generalScore;
    },
    opportunitiesCount(): OpportunitiesCount {
      return typedStore(this).state.opportunities.opportunitiesCount;
    },
    isMyProfile(): boolean {
      return typedStore(this).state.geek.geek.id === typedStore(this).state.geek.current.id;
    },
    getTranslationSuffixOfUser(): string {
      return this.isMyProfile ? 'my' : 'geek';
    },
    activeRouteName(): string {
      return this.$route.name || '';
    },
    profileId(): string {
      return this.$route.params.geekId;
    },
    activeSeasonIdRouteParam(): string | null {
      return this.activeSeason.id ? this.activeSeason.id : null;
    },
  },
  methods: {
    async updateNick(nick: string) {
      this.loader.isProfilePending = true;
      await this.$store.dispatch(Actions.geek.setNick, nick);
      await this.$store.dispatch(Actions.geek.fetchGeekBasicInfo);
      this.loader.isProfilePending = false;
    },
    async setSeason(season: Season) {
      this.loader.isProfilePending = true;
      this.activeSeason = season;
      this.$router.push({params: {geekId: this.profileId}, query: {seasonId: season.id}});
      await this.$store.dispatch(
        Actions.scores.fetchGeekGeneralScore,
        { seasonId: season.id, geekId: this.geekBasicInfo.id },
      );
      await this.$store.dispatch(
        Actions.scores.fetchGeekSkillScores,
        { seasonId: season.id, geekId: this.geekBasicInfo.id },
      );
      this.loader.isProfilePending = false;
    },
    initializeProfile() {
      throw new Error('Method not implemented.');
    },
    resetStoredGeekProfile() {
      this.$store.dispatch(Actions.geek.resetGeekInfo);
      this.$store.dispatch(Actions.scores.resetGeekGeneralScore);
      this.$store.dispatch(Actions.scores.resetGeekSkillScores);
      this.$store.dispatch(Actions.achievements.resetGeekAchievements);
      this.$store.dispatch(Actions.badges.resetGeekBadgesCount);
      this.$store.dispatch(Actions.history.resetLatestAccomplishment);
    },
  },
  watch: {
    '$route.params.geekId'() {
      this.initializeProfile();
    },
  },
});
